export default __webpack_public_path__ + "static/media/carousel-3.e93c87d7.png";